// 表格配置常量
export const COLUMN_CONFIG = {
    exclusiveGroups: [
        { index: 3, key: 'f_growth_zone', type: 'checkbox' },
        { index: 4, key: 'growth_zone', type: 'checkbox' },
        { index: 5, key: 'h_growth_zone', type: 'checkbox' },
    ]

}

// 单元格类名常量
export const CELL_CLASSES = {
    BORDERED: 'bordered',
    NO_BORDER: 'no-border',
    NO_BG: 'nobg',
    CHECKBOX: 'ckbox'
}

// 表格数据生成器
export default {
    // 获取互斥键
    getExclusiveKeys() {
        return COLUMN_CONFIG.exclusiveGroups.map(item => item.key)
    },

    // 生成顶部行
    generateTopRows(headerData, previewMode = false, lang, vueInstance) {
        if (!headerData) return []
        return [
            {
                isDeep: true,
                cells: [
                    { content: '', colspan: 2 },
                    {
                        content: vueInstance.$t('potentialTitle'),
                        colspan: 5,
                    }
                ]
            },
            {
                isDeep: true,
                cells: [
                    { content: '', colspan: 2, },
                    { content: '', },
                    { content: vueInstance.$t('potential_left'), className: `${CELL_CLASSES.CHECKBOX}` },
                    { content: vueInstance.$t('potential_middle'), className: `${CELL_CLASSES.CHECKBOX}` },
                    { content: vueInstance.$t('potential_right'), className: ` ${CELL_CLASSES.CHECKBOX}` },
                    { content: '', }
                ]
            },
            this.generateMiddleMergedRow(headerData, previewMode, lang)
        ]
    },
    // 生成中间行
    generateMiddleRows(dataArray, previewMode = false, lang) {
        if (dataArray.length < 5) return []

        const rows = []

        // 前4行
        for (let i = 0; i < 4; i++) {
            rows.push(this.generateMiddleStandardRow(dataArray[i], i, previewMode, lang))
        }

        // 第5行（合并行）
        rows.push(this.generateMiddleMergedRow(dataArray[4], previewMode, lang))

        return rows
    },
    getLocalizedContent(data, key, lang) {
        const isZh = lang === 'zh';
        const keys = {
            type: { zh: 'type_name', en: 'type_ename' },
            blue: { zh: 'blue_comment_name', en: 'blue_comment_ename' },
            comment1: { zh: 'comment_one_name', en: 'comment_one_ename' },
            comment2: { zh: 'comment_two_name', en: 'comment_two_ename' }
        };

        const field = keys[key] ? (isZh ? keys[key].zh : keys[key].en) : key;
        return data[field] || '';
    },

    generateMiddleRow(data, config, lang, previewMode = false) {
        const { isMerged = false, rowIndex = 0 } = config;
        const cells = [];

        // 第一列处理
        if (!isMerged && rowIndex === 0) {
            cells.push({
                content: this.getLocalizedContent(data, 'type', lang),
                rowspan: 4,
                className: CELL_CLASSES.BORDERED
            });
        }

        // 中间单元格生成
        if (isMerged) {
            // 合并模式
            const mergedContent = `<div ><h3>${this.getLocalizedContent(data, 'type', lang)}</h3>${this.getLocalizedContent(data, 'blue', lang)}</div>`;
            cells.push({
                content: mergedContent,
                colspan: 2,
                className: CELL_CLASSES.BORDERED
            });
        } else {
            let content = this.getLocalizedContent(data, 'blue', lang)
            content = content.replace(':', ':<br/>')
            // 标准模式（第二列）
            cells.push({
                content: content,
                className: CELL_CLASSES.BORDERED
            });
        }

        // 公共部分
        const commonCells = [
            { content: this.getLocalizedContent(data, 'comment1', lang), className: `${CELL_CLASSES.BORDERED} ${CELL_CLASSES.NO_BG}` },
            ...this.generateCheckboxCells(data, [3, 4, 5], previewMode),
            { content: this.getLocalizedContent(data, 'comment2', lang), className: `${CELL_CLASSES.BORDERED} ${CELL_CLASSES.NO_BG}` }
        ];

        return { cells: [...cells, ...commonCells] };
    },

    // 生成标准中间行
    generateMiddleStandardRow(data, rowIndex, previewMode, lang) {
        return this.generateMiddleRow(data, { rowIndex }, lang, previewMode);
    },

    // 生成合并的中间行
    generateMiddleMergedRow(data, previewMode, lang) {
        return this.generateMiddleRow(data, { isMerged: true }, lang, previewMode);
    },
    // 生成底部行
    generateBottomRows(obj, lang) {
        return [
            {
                isDeep: true,
                cells: [
                    { content: '', colspan: 2, className: CELL_CLASSES.NO_BORDER },
                    { content: lang == 'zh' ? obj.potentialName : obj.potentialEName, colspan: 1, className: CELL_CLASSES.BORDERED },
                    {
                        content: lang == 'zh' ? obj.comment : obj.enComment,
                        colspan: 4,
                        className: CELL_CLASSES.BORDERED
                    }
                ]
            }
        ]
    },

    // 生成复选框单元格
    generateCheckboxCells(data, columnIndices) {
        return columnIndices.map(index => {
            const column = COLUMN_CONFIG.exclusiveGroups.find(item => item.index === index)
            const cellValue = data[column.key] || '0'
            // 预览模式下显示文本，编辑模式下显示复选框
            return {
                content: cellValue,
                // 预览模式下设为文本类型，编辑模式下设为复选框类型
                type: 'checkbox',
                key: column.key,
                className: `${CELL_CLASSES.BORDERED} ${CELL_CLASSES.NO_BG} ${CELL_CLASSES.CHECKBOX}`,

            }
        }).filter(Boolean)
    }
}


// WEBPACK FOOTER //
// ./src/components/process/performanceManagement/components/PotentialRangeComponents/table-config.js